import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-663e861c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid font-goldplay" }
const _hoisted_2 = { class: "row align-items-center border-bottom border-dark m-1" }
const _hoisted_3 = { class: "row align-items-center border-bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Title ", -1))
const _hoisted_5 = { class: "col font-14px" }
const _hoisted_6 = { class: "row align-items-center border-bottom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Date ", -1))
const _hoisted_8 = { class: "col font-14px" }
const _hoisted_9 = { class: "row align-items-center border-bottom" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Time ", -1))
const _hoisted_11 = { class: "col font-14px" }
const _hoisted_12 = { class: "row align-items-center border-bottom" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Webinar Link ", -1))
const _hoisted_14 = { class: "col font-14px" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 0,
  class: "row align-items-center border-bottom"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Documents ", -1))
const _hoisted_20 = { class: "col font-14px" }

import { ref } from 'vue'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import DocumentIcon from '@/icons/DocumentIcon.vue'
import DocumentDownloadModal from '../DocumentDownloadModal/DocumentDownloadModal.vue'
import { useClassroomStudentService } from '../ClassroomStudentService'
import { downloadFile } from '@/utils/downloadFile'


export default /*#__PURE__*/_defineComponent({
  __name: 'WebinarMobileListItem',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    isLastRow: { type: Boolean }
  },
  setup(__props: any) {

const props =
  __props

const dateString = props.modelValue.localStartDateTime.toLocaleString('en-us', {month: 'long', day: 'numeric', year: 'numeric'})
const hasWebinarPassed = props.modelValue.localEndDateTime < new Date()
const hasDocuments = props.modelValue.event.documentFileNames?.length > 0

const classroomStudentService = useClassroomStudentService()
const showDocumentDownloadModal = ref(false)
const documentsDownloading = ref([''])

function handleDownloadDocuments() {
  if (props.modelValue.event.documentFileNames.length === 1) {
    downloadFiles([props.modelValue.event.documentFileNames[0]])
  } else {
    openDocumentDownloadModal()
  }
}

async function downloadFiles(fileNameList: string[]) {
  documentsDownloading.value = [ ...fileNameList ]
  try {
    await fileNameList.forEach(async (fileName) => {
      const file = await classroomStudentService.fetchEventDocument(props.modelValue.sessionId, fileName)
      if (file) {
        downloadFile(file, fileName)
        documentsDownloading.value = documentsDownloading.value.filter(f => f !== fileName)
      }
    })
  } catch (e) {
    documentsDownloading.value = []
    throw e
  }
}

function openDocumentDownloadModal() {
  showDocumentDownloadModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.modelValue.event.description), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(dateString)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.modelValue.localStartEndTime), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (!hasWebinarPassed)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.modelValue.event.meetingLink
                }, " Webinar Link ", 8, _hoisted_15))
              : (_ctx.modelValue.event.recordingLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _ctx.modelValue.event.recordingLink
                  }, " Recorded Webinar Link ", 8, _hoisted_16))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, " Unavailable "))
          ])
        ]),
        hasDocuments
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn p-0 lh-1 rounded-0",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownloadDocuments()))
                }, [
                  _createVNode(DocumentIcon, { class: "size-20px" })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(DocumentDownloadModal, {
      visible: showDocumentDownloadModal.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showDocumentDownloadModal).value = $event)),
      "file-names": _ctx.modelValue.event.documentFileNames ?? [],
      "documents-downloading": documentsDownloading.value,
      onDownloadFiles: downloadFiles
    }, null, 8, ["visible", "file-names", "documents-downloading"])
  ], 64))
}
}

})